import { GitError } from '../wasm-git-worker-errors.model';
import { GitErrorStatusCode } from './errors.enum';

export class WriteFileGitError extends GitError {
  constructor(filePath: string, append = true) {
    super(append ? `Error writing file at "${filePath}"` : filePath);
  }

  readonly gitErrorCode = GitErrorStatusCode.WriteFile;
}
